export default __webpack_public_path__ + "media/src/assets/images/PredefinedLocation-3f4250c2b1ef36e2fc58b24ab50e9447.svg";